import { useEffect, useState } from "react";
import QueueStatusTable from "../../Tables/ApplyOption/QueueStatus/QueueStatusTable";
import Config from "./Config";
import Progress from "./Progress";
import StatusesBox from "./StatusesBox";
import TablesWrapper from "./TablesWrapper";

const ApplyOption = () => {
  const [progressRefreshFlag, setProgressRefreshFlag] = useState(true);
  const [activeTableRefreshFlag, setActiveTableRefreshFlag] = useState(false);
  const [configVersion, setConfigVersion] = useState(0);

  useEffect(() => {
    if (!activeTableRefreshFlag) return;
    setTimeout(() => {
      setActiveTableRefreshFlag(false);
    }, 300);
  }, [activeTableRefreshFlag]);

  return (
    <div className="px-4 flex flex-col justify-start items-start gap-5 w-full">
      <div className="flex flex-row justify-start items-center gap-5 w-full">
        <Config onSaved={() => {
          setConfigVersion((version) => version + 1);
          setActiveTableRefreshFlag(true);
        }} />
        <Progress
          refreshFlag={progressRefreshFlag}
          setRefreshFlag={setProgressRefreshFlag}
        />
      </div>

      <QueueStatusTable />

      <StatusesBox
        refreshActiveTable={() => setActiveTableRefreshFlag(true)}
      />

      <TablesWrapper activeTableRefreshFlag={activeTableRefreshFlag} configVersion={configVersion} />
    </div>
  );
};

export default ApplyOption;
